import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import {GroupedData} from "../../data-structures/group"
import CustomFieldsManager from "../../gd/manager/custom-fields-manager"
import Field1ToField2Converter from "../../fields3/fields-converter-1-2"
import FieldsFactory from "../../fields3/fields-factory"
import FieldCrmAccount from "../../fields3/system/crm/account/crm-account"
import FieldEstimatedCostInternal from "../../fields3/generic/finance/cost-estimated/estimated-cost-internal"
import FieldEstimatedCostExternal from "../../fields3/generic/finance/cost-estimated/estimated-cost-external"
import FieldProjectEstimateTasks from "../../fields3/system/project/estimate/estimate-tasks"
import FieldProjectEstimate from "../../fields3/system/project/estimate/estimate"
import FieldDate from "../../fields3/generic/datetime/date/date"
import FieldProjectPriority from "../../fields3/system/project/priority/priority"
import FieldProjectOwner from "../../fields3/system/project/owner/project-owner"
import FieldProjectUsers from "../../fields3/system/project/users/users"
import FieldProjectStartDate from "../../fields3/system/project/dates/start/start-date"
import FieldProjectEndDate from "../../fields3/system/project/dates/end/end-date"
import FieldProjectDurationWorkdays from "../../fields3/system/project/duration/duration-workdays"
import FieldProjectDurationCalendar from "../../fields3/system/project/duration/duration-calendar"
import FieldProjectProgress from "../../fields3/system/project/progress/progress"
import FieldProjectProgressItems from "../../fields3/system/project/progress-items/progress-items"
import FieldText from "../../fields3/generic/text/text"
import FieldProjectTotalOpenAll from "../../fields3/system/project/total-open-all/total-open-all"
import FieldProjectColor from "../../fields3/system/project/color/color"
import FieldProjectStartEnd from "../../fields3/system/project/dates/start-end/start-end"
import FieldProjectHealth from "../../fields3/system/project/health/health"
import FieldPredecessors from "../../fields3/generic/dependency/predecessors/predecessors"
import FieldSuccessors from "../../fields3/generic/dependency/successors/dependants"
import FieldProjectStatus from "../../fields3/system/project/status/project-status"
import FieldProjectProgressTasks from "../../fields3/system/project/progress-tasks/progress-tasks"
import FieldProjectType from "../../fields3/system/project/type/type"
import FieldProjectParent from "../../fields3/system/project/parent/parent"
import FieldProjectAccess from "../../fields3/system/project/access/project-access"
import FieldProjectColorIcon from "../../fields3/system/project/color-icon/color-icon"
import FieldProjectSystemStatus from "../../fields3/system/project/system-status/system-status"
import FieldString from "../../fields3/generic/string/string";
import FieldProjectAccessMode from "../../fields3/system/project/access-mode/access-mode"
import FieldIcon from "../../fields3/generic/icon/icon"
import FieldConfig from "../../fields3/proto/field-config"
import {IconType} from "../../gd-components/selector/icon-selector/@const"
import {PROJECT_ICON_CATEGORIES} from "../../gd/const/item-icon/project-categories"
import FieldDropdown from "../../fields3/generic/dropdown/dropdown"
import {ProjectDataField} from "./data-fields/@types"
import {ProjectSystemType} from "./types"
import FieldProjectName from "../../fields3/system/project/name/project-name"
import FieldProjectMomentCreated from "../../fields3/system/project/dates/moment-created/moment-created"
import FieldProto from "../../fields3/proto/field-proto"
import {ColumnID, SystemColumnType} from "../../gd-modules/manager/columns/types"
import FieldAttachmentsTotal from "../../fields3/generic/total/attachments/attachments-total"
import FieldCurrency from "../../fields3/generic/finance/currency/currency"
import FieldStoryPoints from "../../fields3/generic/story-points/story-points"
import FieldItemModelTimeReportedCalculated
    from "../../fields3/system/item-model/time-reported-calculated/time-reported-calculated"
import FieldItemModelCalculatedExpenses from "../../fields3/system/item-model/calculated-expenses/calculated-expenses"
import FieldItemModelCalculatedSpentEstimate
    from "../../fields3/system/item-model/calculated-spent-estimate/calculated-spent-estimate"
import FieldMessagesTotal from "../../fields3/generic/total/messages/messages-total"
import FieldProjectReportedByUsers from "../../fields3/system/project/reported-by-users/reported-by-users"
import {tagScopeOptions} from "../tag/const";

const baseConfig: FieldConfig[] = [

    {
        fieldId: 'id',
        type: FieldType.PROJECT
    },
    {
        fieldId: 'statusId',
        label: 'Status',
        type: FieldType.PROJECT_STATUS
    },
    {
        fieldId: 'systemStatus',
        label: 'System status',
        type: FieldType.PROJECT_SYSTEM_STATUS
    },
    {
        fieldId: 'systemType',
        label: 'System type',
        type: FieldType.DROPDOWN,
        showMenuMore: false,
        noValueOption: false,
        options: [
            {label: "Project", value: ProjectSystemType.PROJECT,},
            {label: "Folder", value: ProjectSystemType.FOLDER,},
            {label: "Backlog", value: ProjectSystemType.BACKLOG,},
            {label: "Sprint", value: ProjectSystemType.SPRINT,},
        ]
    },
    {
        fieldId : 'title',
        label   : 'Title',
        type    : FieldType.PROJECT_NAME
    },
    {
        fieldId : 'name',
        label   : 'Name',
        type    : FieldType.PROJECT_NAME
    },
    {
        fieldId                 : 'statusComments',
        label                   : 'Status comments',
        type                    : FieldType.TEXT,
        noDefaultPaddingMargin  : true,
        dataFields              : [ProjectDataField.statusComments]
    },
    {
        fieldId         : 'color',
        type            : FieldType.PROJECT_COLOR
    },
    {
        fieldId         : 'projectIcon',
        label           : 'Icon',
        type            : FieldType.ICON,
        fieldParams: {
            iconTypes       : [IconType.ITEM_ICONS, IconType.EMOJI_ICONS, IconType.URL],
            iconCategories  : PROJECT_ICON_CATEGORIES
        }
    },
    {
        fieldId         : 'projectColorIcon',
        label           : 'Color / Icon',
        type            : FieldType.PROJECT_COLOR_ICON
    },
    {
        fieldId         : 'ownerUserId',
        label           : 'Project owner',
        type            : FieldType.PROJECT_OWNER,
        icon            : 'i5-user',
        dataFields      : [ProjectDataField.ownerUserId]
    },
    {
        fieldId: 'health',
        label: 'Health',
        type: FieldType.PROJECT_HEALTH
    },
    {
        fieldId     : 'momentCreated',
        label       : 'Date Created',
        type        : FieldType.PROJECT_MOMENT_CREATED,
        dataFields  : [ProjectDataField.dateCreated]
    },
    {
        fieldId: 'deadline',
        label: 'Deadline',
        type: FieldType.PROJECT_DEADLINE
    },
    {
        fieldId: 'startEnd',
        label: 'Start-End',
        type: FieldType.PROJECT_START_END
    },
    {
        fieldId     : 'startDate',
        label       : 'Start date',
        type        : FieldType.PROJECT_START,
        icon        : 'i5-date-start'
    },
    {
        fieldId     : 'endDate',
        label       : 'End date',
        type        : FieldType.PROJECT_END,
        icon        : 'i5-date-end'
    },
    {
        fieldId         : 'parentId',
        label           : 'Parent Project',
        type            : FieldType.PROJECT_PARENT
    },
    {
        fieldId         : 'projectType',
        label           : 'Project Type',
        type            : FieldType.PROJECT_TYPE
    },
    {
        fieldId: 'priority',
        label: 'Priority',
        type: FieldType.PROJECT_PRIORITY,
        noDefaultPaddingMargin: true
    },
    {
        fieldId     : 'estimate',
        label       : 'Estimate',
        type        : FieldType.PROJECT_ESTIMATE
    },
    {
        fieldId     : 'estimateTasks',
        label       : 'Estimate, tasks total',
        type        : FieldType.PROJECT_ESTIMATE_TASKS,
        dataFields  : [ProjectDataField.tasks],
    },
    {
        fieldId: 'progress',
        label: 'Progress',
        type: FieldType.PROJECT_PROGRESS
    },
    {
        fieldId: 'access',
        type: FieldType.PROJECT_ACCESS
    },
    {
        fieldId: 'dateCreated',
        label: 'Date created',
        type: FieldType.DATE
    },
    {
        fieldId     : 'description',
        label       : 'Description',
        icon        : 'i5-text',
        type        : FieldType.TEXT,
        dataFields  : [ProjectDataField.description, ProjectDataField.descriptionRtf]
    },
    {
        fieldId: 'crmAccountId',
        label: 'CRM Company',
        type: FieldType.CRM_ACCOUNT
    },
    {
        // has no model field! which is ok ... used in table only
        fieldId         : 'estimatedCostInternal',
        type            : FieldType.ESTIMATED_COST_INTERNAL,
        label           : 'Estimated labor cost',
        dataFields      : [ProjectDataField.tasks],
    },
    {
        // has no model field! which is ok ... used in table only
        fieldId         : 'estimatedCostExternal',
        type            : FieldType.ESTIMATED_COST_EXTERNAL,
        label           : 'Estimated service cost',
        dataFields      : [ProjectDataField.tasks],
    },
    {
        fieldId         : 'localTemplateId',
        type            : FieldType.PROJECT_TEMPLATE,
        label           : 'Project Type'
    },
    {
        fieldId         : 'users',
        type            : FieldType.PROJECT_USERS,
        dataFields      : [ProjectDataField.users],
    },
    {
        fieldId         : 'reportedByUsersIds',
        type            : FieldType.PROJECT_REPORTED_BY_USERS,
    },
    {
        fieldId     : 'durationWorkdays',
        label       : 'Duration, workdays',
        type        : FieldType.PROJECT_DURATION_WORKDAYS,
    },
    {
        fieldId     : 'durationCalendar',
        label       : 'Duration, calendar',
        type        : FieldType.PROJECT_DURATION_CALENDAR,
    },
    {
        fieldId     : 'progressItems',
        label       : 'Progress, items',
        type        : FieldType.PROJECT_PROGRESS_ITEMS,
        dataFields  : [ProjectDataField.tasksOpen, ProjectDataField.tasksTotal],
    },
    {
        fieldId     : 'totalOpenAll',
        type        : FieldType.PROJECT_TOTAL_OPEN_ALL
    },
    {
        fieldId         : 'predecessors',
        type            : FieldType.PREDECESSORS,
        label           : 'Depends on'
    },
    {
        fieldId         : 'successors',
        type            : FieldType.SUCCESSORS,
        label           : 'Dependants'
    },
    {
        fieldId         : 'progressTasks',
        label           : 'Progress Tasks',
        type            : FieldType.PROJECT_PROGRESS_TASKS,
        dataFields      : [ProjectDataField.tasksOpen, ProjectDataField.tasksTotal],
    },
    {
        fieldId                 : 'url',
        label                   : 'URL',
        type                    : FieldType.TEXT,
        noDefaultPaddingMargin  : true
    },
    {
        fieldId                 : 'embedCode',
        label                   : 'URL or Embed code',
        type                    : FieldType.TEXT,
        noDefaultPaddingMargin  : true
    },
    {
        fieldId                 : 'accessMode',
        type                    : FieldType.PROJECT_ACCESS_MODE,
        label                   : 'Access Mode',
    },

    // calculated fields
    {
        fieldId         : 'messagesTotal',
        type            : FieldType.MESSAGES_TOTAL,
        label           : 'Messages'
    },
    {
        fieldId         : 'attachmentsTotal',
        type            : FieldType.ATTACHMENTS_TOTAL,
        label           : 'Attachments'
    },
    {
        fieldId         : 'costInternal',
        type            : FieldType.CURRENCY,
        label           : 'Labor cost',
        isDisabled      : true,
    },
    {
        fieldId         : 'costExternal',
        type            : FieldType.CURRENCY,
        label           : 'Service cost',
        isDisabled      : true,
    },
    {
        fieldId         : 'storyPoints',
        type            : FieldType.STORY_POINTS,
        label           : 'Story points',
    },
    {
        fieldId         : 'reportedTime',
        type            : FieldType.ITEM_MODEL_CALCULATED_TIME_REPORTS,
        label           : 'Time reported',
    },
    {
        fieldId         : 'calculatedExpenses',
        label           : 'Expenses',
        type            : FieldType.ITEM_MODEL_CALCULATED_EXPENSES,
        dataFields      : [ProjectDataField.expenses],
    },
    {
        fieldId         : 'spentEstimate',
        label           : 'Spent / Estimated',
        type            : FieldType.ITEM_MODEL_CALCULATED_SPENT_ESTIMATE,
        dataFields      : [ProjectDataField.timeReports],
    },
    {
        fieldId         : "tagScope",
        type            : FieldType.DROPDOWN,
        options         : tagScopeOptions,
        noValueOption   : false,
        showMenuMore    : false,
        classes         : {
            PopoverMenu : 'max-w-300'
        }
    }
]

export default class ProjectFields extends FieldsCollection {

    private isCompanyManager: boolean = false

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.PROJECT);

        this.isCompanyManager = gd.ac.check.company.isManager(gd.companyId)
        this.initAllCustomFields()
    }

    getByColumnId(columnId: ColumnID): FieldProto | undefined {

        const ProjectFieldsColumnToFieldMap: Partial<Record<SystemColumnType, FieldProto | undefined>> = {
            [SystemColumnType.TASK_TYPE]                        : this.projectType,
            [SystemColumnType.STATUS]                           : this.statusId,
            [SystemColumnType.PRIORITY]                         : this.priority,
            [SystemColumnType.OWNER]                            : this.projectOwner,
            [SystemColumnType.USERS]                            : this.users,
            [SystemColumnType.REPORTED_BY]                      : this.reportedByUsersIds,
            [SystemColumnType.START_END_DATE]                   : this.startEnd,
            [SystemColumnType.DEADLINE]                         : this.deadline,
            [SystemColumnType.START_DATE]                       : this.startDate,
            [SystemColumnType.END_DATE]                         : this.endDate,
            [SystemColumnType.DATE_CREATED]                     : this.momentCreated,
            [SystemColumnType.DURATION_CALENDAR_DAYS]           : this.durationCalendar,
            [SystemColumnType.DURATION_WORK_DAYS]               : this.durationWorkdays,
            [SystemColumnType.STORY_POINTS]                     : this.storyPoints, //gd.fields.itemModel.calculatedStoryPoints,
            [SystemColumnType.ESTIMATE]                         : this.estimate, //gd.fields.itemModel.calculatedEstimated,
            [SystemColumnType.TIME_REPORTED]                    : this.reportedTime, //gd.fields.itemModel.calculatedTimeReports,
            [SystemColumnType.SPENT_ESTIMATE]                   : this.spentEstimate, //gd.fields.itemModel.calculatedSpentEstimated,
            [SystemColumnType.PROGRESS_BAR]                     : this.progress,
            [SystemColumnType.PROGRESS_ITEMS]                   : this.progressItems,
            [SystemColumnType.PROGRESS_TASKS]                   : this.progressTasks,
            // [SystemColumnType.COST_EXPENSES]                    : gd.fields.itemModel.calculatedExpenses,
            [SystemColumnType.ITEM_MODEL_CALCULATED_EXPENSES]   : this.calculatedExpenses, //gd.fields.itemModel.calculatedExpenses,
            [SystemColumnType.COST_INTERNAL]                    : this.costInternal, //gd.fields.itemModel.calculatedLaborCost,
            [SystemColumnType.COST_EXTERNAL]                    : this.costExternal, //gd.fields.itemModel.calculatedServiceCost,
            [SystemColumnType.ESTIMATED_COST_INTERNAL]          : this.estimatedCostInternal,
            [SystemColumnType.ESTIMATED_COST_EXTERNAL]          : this.estimatedCostExternal,
            [SystemColumnType.COMMENTS]                         : this.statusComments,
            [SystemColumnType.OPEN_ALL]                         : this.totalOpenAll,
            [SystemColumnType.PROJECT_COLOR]                    : this.color,
            [SystemColumnType.PROJECT_HEALTH]                   : this.health,
            [SystemColumnType.MESSAGES_TOTAL]                   : this.messagesTotal,
            [SystemColumnType.ATTACHMENTS_TOTAL]                : this.attachmentsTotal,
            [SystemColumnType.DEPENDS_ON]                       : this.predecessors,
            [SystemColumnType.DEPENDANTS]                       : this.successors,
            [SystemColumnType.PROJECT_ESTIMATE]                 : this.estimate,
            [SystemColumnType.PROJECT_ESTIMATE_TASKS]           : this.estimateTasks,
            [SystemColumnType.CRM_ACCOUNT]                      : this.crmAccountId,
            [SystemColumnType.DESCRIPTION]                      : this.description,
            [SystemColumnType.PROJECT_PATH]                     : this.parentId,
            [SystemColumnType.COST_EXPENSES]                    : this.calculatedExpenses,
        }

        return ProjectFieldsColumnToFieldMap[columnId as SystemColumnType]
    }

    get title()                         : FieldProjectName { return this.get('title') as FieldProjectName}
    get name()                          : FieldProjectName { return this.get('name') as FieldProjectName}
    get description()                   { return this.get('description') as FieldText}
    get statusId()                      { return this.get('statusId') as FieldProjectStatus}
    get systemStatus()                  { return this.get('systemStatus') as FieldProjectSystemStatus}
    get systemType()                    { return this.get('systemType') as FieldDropdown}
    get deadline()                      { return this.get('deadline') as FieldDate}
    get startDate()                     { return this.get('startDate') as FieldProjectStartDate}
    get endDate()                       { return this.get('endDate') as FieldProjectEndDate}
    get startEnd()                      { return this.get('startEnd') as FieldProjectStartEnd}
    get momentCreated()                 : FieldProjectMomentCreated { return this.get('momentCreated') as FieldProjectMomentCreated }
    get crmAccountId()                  { return this.get('crmAccountId') as FieldCrmAccount}
    get estimatedCostInternal()         { return this.get('estimatedCostInternal') as FieldEstimatedCostInternal}
    get estimatedCostExternal()         { return this.get('estimatedCostExternal') as FieldEstimatedCostExternal}
    get estimateTasks()                 { return this.get('estimateTasks') as FieldProjectEstimateTasks}
    get estimate()                      { return this.get('estimate') as FieldProjectEstimate }
    get priority()                      { return this.get('priority') as FieldProjectPriority }
    get projectOwner()                  { return this.get('ownerUserId') as FieldProjectOwner }
    get users()                         : FieldProjectUsers { return this.get('users') as unknown as FieldProjectUsers }
    get reportedByUsersIds()            : FieldProjectReportedByUsers { return this.get('reportedByUsersIds') as unknown as FieldProjectReportedByUsers }
    get durationWorkdays()              { return this.get('durationWorkdays') as FieldProjectDurationWorkdays}
    get durationCalendar()              { return this.get('durationCalendar') as FieldProjectDurationCalendar}
    get progress()                      { return this.get('progress') as FieldProjectProgress}
    get progressItems()                 { return this.get('progressItems') as FieldProjectProgressItems }
    get progressTasks()                 { return this.get('progressTasks') as FieldProjectProgressTasks }
    get statusComments()                { return this.get('statusComments') as FieldText }
    get totalOpenAll()                  { return this.get('totalOpenAll') as FieldProjectTotalOpenAll }
    get color()                         { return this.get('color') as FieldProjectColor }
    get projectIcon()                   { return this.get('projectIcon') as FieldIcon }
    get projectColorIcon()              { return this.get('projectColorIcon') as FieldProjectColorIcon }
    get health()                        { return this.get('health') as FieldProjectHealth }
    get messagesTotal()                 : FieldMessagesTotal { return this.get('messagesTotal') as FieldMessagesTotal}
    get attachmentsTotal()              : FieldAttachmentsTotal { return this.get('attachmentsTotal') as FieldAttachmentsTotal}
    get predecessors()                  { return this.get('predecessors') as FieldPredecessors}
    get successors()                    { return this.get('successors') as FieldSuccessors}
    get projectType()                   { return this.get('projectType') as FieldProjectType}
    get parentId()                      { return this.get('parentId') as FieldProjectParent}
    get access()                        { return this.get('access') as FieldProjectAccess}
    get accessMode()                    { return this.get('accessMode') as FieldProjectAccessMode}

    // property fields
    get url()                           { return this.get('url') as FieldText }

    // view fields
    get embedCode()                     { return this.get('embedCode') as FieldText }

    // calculated fields
    get costInternal()                  : FieldCurrency { return this.get('costInternal') as FieldCurrency}
    get costExternal()                  : FieldCurrency { return this.get('costExternal') as FieldCurrency}
    get storyPoints()                   : FieldStoryPoints { return this.get('storyPoints') as FieldStoryPoints}
    get reportedTime()                  : FieldItemModelTimeReportedCalculated { return this.get('reportedTime') as FieldItemModelTimeReportedCalculated}
    get calculatedExpenses()            : FieldItemModelCalculatedExpenses { return this.get('calculatedExpenses') as FieldItemModelCalculatedExpenses}
    get spentEstimate()                 : FieldItemModelCalculatedSpentEstimate { return this.get('spentEstimate') as FieldItemModelCalculatedSpentEstimate}
    get tagScope()                      : FieldDropdown { return this.get('tagScope') as FieldDropdown}

    // Used at least in TABLE view... chto mne ne nravitsya esli chestno
    getFieldByField1Id(id:string) {
        let res
        switch (id) {
            case FieldType.PROJECT_ESTIMATE             : return this.estimate
            case FieldType.PROJECT_ESTIMATE_TASKS       : return this.estimateTasks
            case gd.const.fields.type.CRM_ACCOUNT       : return this.crmAccountId // need in table
            case FieldType.ESTIMATED_COST_INTERNAL      : return this.estimatedCostInternal // need in table
            case FieldType.ESTIMATED_COST_EXTERNAL      : return this.estimatedCostExternal // need in table
            // case 'noGrouping'                           : res = null; break
            default:
                /* in this case id is customFieldId */
                res = this.get(id);
                return res
        }
    }


    public hasField = (fieldId:fieldId): boolean => {
        return !!_.find(this._fields, field=>field.fieldId === fieldId)
    }

    private isCustomFieldAvailable = (customField:any): boolean => {
        return (this.isCompanyManager || customField.access === gd.const.customFields.access.EVERYONE) &&
            _.intersection(customField.params.scope, [gd.const.customFields.scope.PROJECT]).length > 0 &&
            !customField.isDeleted
    }

    public addCustomField(customField:any) {
        if (!this.isCustomFieldAvailable(customField)) return

        const field2Config = Field1ToField2Converter.getField2Config(customField.id)
        if (field2Config                                                // field config successfully created
            && !this.hasField(field2Config.fieldId)                     // field with same ID does not exist in this (ProjectFields) fields collection
            && gd.session.customFields.get(field2Config?.fieldId)) {    // custom field exists in session
            // @ts-ignore
            this.addField(FieldsFactory.get(field2Config))
        }
    }

    public initAllCustomFields() {
        const customFields = CustomFieldsManager.getOrganizationCustomFields(gd.companyId, [gd.const.customFields.scope.PROJECT])
        _.map(customFields, customField=>{
            this.addCustomField(customField)}
        )
    }

    get structureGroupBy():GroupedData {
        return [
            {
                value   : 'generic',
                label   : 'Generic',
                type    : 'system',
                items   : [
                    this.get('statusId'),
                    this.get('priority'),
                    this.get('health'),
                    this.get('projectType'),
                ]
            },
            {
                value   : 'users',
                label   : 'Users',
                type    : 'system',
                items   : [
                    this.get('ownerUserId'),
                ]
            },
            // dissabled for now
            // {
            //     value   : 'dates',
            //     label   : 'Dates',
            //     type    : 'system',
            //     items   : [
            //         this.get('deadline'),
            //     ]
            // },
            {
                value   : 'estimate',
                label   : 'Estimate',
                type    : 'system',
                items   : [
                    this.get('estimate'),
                ]
            },
            {
                value   : 'progress',
                label   : 'Progress',
                type    : 'system',
                items   : [
                    this.get('progress'),
                ]
            }
        ]
    }

    structureColorCoding():GroupedData {
        return [
            {
                value   : 'generic',
                label   : 'System fields',
                type    : 'system',
                items   : [
                    this.get('color'),
                    this.get('statusId'),
                    this.get('priority'),
                    this.get('health'),
                ]
            }
        ]
    }

    get structureProjectInfo():GroupedData {
        return [
            {
                value   : 'system',
                label   : 'System fields',
                type    : 'system',
                items   : [
                    this.get('deadline'),
                    this.get('startEnd'),
                    this.get('priority'),
                    this.get('estimate'),
                    this.get('progress'),
                    this.get('health'),
                    // this.get('description'),
                ]
            },

            {
                value   : 'generic',
                label   : 'Custom fields',
                type    : 'system',
                items   : this.customFields()
            },
        ]
    }

    get structureConditions(): GroupedData {

        this.initAllCustomFields()

        const customFields: FieldProto[] = _.filter(this.customFields(), (field: FieldProto) => {
            switch (field.type) {
                case FieldType.ATTACHMENT:
                case FieldType.FORMULA:
                case FieldType.VOTING:
                case FieldType.REACTION:
                case FieldType.DATE_AND_TIME:
                case FieldType.TIME_OF_DAY:
                    return false
            }
            return true
        })

        return [
            {
                value : 'general',
                label : 'General',
                type  : 'system',
                items : [
                    this.statusId,
                    this.systemStatus,
                    this.priority,
                    this.projectType,
                    this.health,
                ]
            },
            {
                value : 'users',
                label : 'Users',
                type  : 'system',
                items : [
                    this.users,
                    this.projectOwner,
                ]
            },
            {
                value : 'dates',
                label : 'Dates',
                type  : 'system',
                items : [
                    this.deadline,
                    this.startDate,
                    this.endDate,
                    this.momentCreated,
                ]
            },
            {
                value : 'estimate',
                label : 'Estimate',
                type  : 'system',
                items : [
                    this.estimate,
                ]
            },
            {
                value : 'progress',
                label : 'Progress',
                type  : 'system',
                items : [
                    this.progress,
                ]
            },
            {
                value : 'custom-fields',
                label : 'Custom',
                type  : 'custom-fields',
                items : customFields,
            }
        ]
    }

    structureFilterFields(customFields?: any[]): GroupedData {
        const customFieldsV1: any[] = _.chain(customFields || [])
            .orderBy(c=>c.name, 'asc')
            .value();

        const filterCustomFields: FieldProto[] = []

        _.map(customFieldsV1, (customFieldV1)=> {

            const field2Config: FieldConfig | null = Field1ToField2Converter.getField2Config(customFieldV1.id)
            if (field2Config && gd.session.customFields.get(field2Config?.fieldId)) {    // custom field exists in session

                field2Config.entityType = EntityType.PROJECT
                const field3 = FieldsFactory.get(field2Config)

                if (field3.isFilterAvailable) {
                    filterCustomFields.push(field3)
                }
            }
        })

        const result = [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    this.title,
                    this.statusId,
                    this.systemStatus,
                    this.priority,
                    this.projectType,
                    this.health,

                ]
            },
            {
                value   : 'users',
                label   : 'Users',
                type    : 'system',
                items   : [
                    this.users,
                    this.projectOwner
                ]
            },
            {
                value  : 'dates',
                label  : 'Dates',
                type   : 'system',
                items  : [
                    this.deadline,
                    this.startDate,
                    this.endDate,
                    this.momentCreated,
                ]
            },
            {
                value   : 'estimate',
                label   : 'Estimate',
                type    : 'system',
                items   : [
                    this.estimate
                ]
            },
            {
                value   : 'timeAndProgress',
                label   : 'Time & Progress',
                type    : 'system',
                items   : [
                    this.progress
                ]
            },
            {
                value   : 'crm',
                label   : 'CRM',
                type    : 'system',
                items   : [
                    this.crmAccountId
                ]
            },

            {
                value   : 'custom-fields',
                label   : 'Custom',
                type    : 'custom-fields',
                items   : filterCustomFields
            }
        ]

        return result
    }

}
